import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import socket, { joinRoom, connectSocket } from '../socket';
import api from '../axiosConfig';
import '../css/presenter.css';
// import productImg from '../assets/AndembryLogo.png';
import Leaderboard from '../common/LeaderBoard';

const Presenter = () => {
  const { id: sessionIdParam } = useParams();

  const [loading, setLoading] = useState(true);
  const [questionLeaderboard, setQuestionLeaderboard] = useState([]);
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [sessionQuestions, setSessionQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(null);
  const [currentStatus, setCurrentStatus] = useState(null);
  // const [sessionId, setSessionId] = useState(null);

  const fetchLeaderboardData = async () => {
    try {
      const response = await api.get(`/leaderboard/loadPresenterData?sessionId=${sessionIdParam || -1}`);
      setQuestionLeaderboard(response.data.questionLeaderboard);
      setLeaderboardData(response.data.leaderboardData);
      setSessionQuestions(response.data.sessionQuestions);
      setCurrentQuestionIndex(response.data.currentQuestionIndex);
      setCurrentStatus(response.data.sessionQuestions[response.data.currentQuestionIndex].step);
      // setSessionId(response.data.sessionId);
      joinRoom(`presenter|${sessionIdParam || response.data.sessionId}`);
    } catch (error) {
      console.error('Error fetching leaderboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateLeaderboard = async (payload) => {
    console.log('Received updateLeaderboard event');

    setQuestionLeaderboard(payload.questionLeaderboard);
  };

  const handleNewQuestion = ({ status, questionIndex, extraContent }) => {
    if (questionIndex !== currentQuestionIndex) {
      fetchLeaderboardData();
    } else {
      setCurrentQuestionIndex(questionIndex);
      setCurrentStatus(status);
    }
    if (extraContent.leaderboardData) {
      setLeaderboardData(extraContent.leaderboardData);
    }
    if (extraContent.questionLeaderboardData) {
      console.log('questionLeaderboardData', extraContent.questionLeaderboardData);
      setQuestionLeaderboard(extraContent.questionLeaderboardData);
    }
  };

  const handleRestartSession = ({ status }) => {
    // console.log("New Session Update")
    fetchLeaderboardData();
  };

  useEffect(() => {
    // Fetch leaderboard data when component mounts
    connectSocket();

    fetchLeaderboardData();

    socket.on('leaderboardUpdate', handleUpdateLeaderboard);
    socket.on('newQuestion', handleNewQuestion);
    socket.on('restarted', handleRestartSession);

    return () => {
      socket.off('leaderboardUpdate', handleUpdateLeaderboard);
      socket.off('newQuestion', handleNewQuestion);
      socket.off('restarted', handleRestartSession);
      socket.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <h1>Loading...</h1>;
  }

  if (!sessionQuestions) {
    return <h1>Session not found</h1>;
  }
  if (leaderboardData.length === 0 || questionLeaderboard.length === 0) return <h1>Loading...</h1>;
  // Render the presenter view

  const renderInnerContent = () => {
    const winner = currentQuestionIndex === sessionQuestions.length - 1;

    // standby
    if (currentStatus === 4) {
      const currentQuestion = sessionQuestions[currentQuestionIndex];

      return (
        <>
          {!winner ? <h1>Next Question....</h1> : null}
          <h2 dangerouslySetInnerHTML={{ __html: currentQuestion.question }}></h2>
        </>
      );
    }

    // leaderboard
    if (currentStatus === 1) {
      return (
        <div>
          <h1 className="knowledge-title">LeaderBoard</h1>
          <Leaderboard leaderboardData={leaderboardData} showWinner={winner} styles={{ color: 'black' }} />
        </div>
      );
    }

    return (
      <h1 className="knowledge-title" style={{ color: 'black' }}>
        Test Your <br /> Knowledge
      </h1>
    );
  };

  const renderBody = () => {
    const currentQuestion = sessionQuestions[currentQuestionIndex];
    const showQuestion = [2, 3].includes(currentStatus);

    if (!currentQuestion) {
      return <div>No current question available.</div>;
    }

    if (showQuestion) {
      const closedStatus = currentStatus === 2;

      const correctAnswer = currentQuestion.answerIndex;

      const maxScore = Math.max(...questionLeaderboard.map((item) => item.score));

      // set winner of question
      const updatedLeaderboard = !closedStatus
        ? questionLeaderboard
        : questionLeaderboard.map((item) => ({
            ...item,
            winner: item.score === maxScore
          }));

      return (
        <div className="presenter-container">
          <div className="presenter-header"></div>
          <h3
            className="presenter-current-question"
            dangerouslySetInnerHTML={{ __html: currentQuestion.question }}
          ></h3>

          <div className="presenter-answers">
            {currentQuestion.options?.map((answer, index) => (
              <div key={index} className={`presenter-answer ${correctAnswer === index ? 'correct' : ''}`}>
                <b>({String.fromCharCode(65 + index)})</b> {answer}
              </div>
            ))}
          </div>

          <div className="presenter-leaderboard">
            {updatedLeaderboard.map((group, index) => {
              const scorePercentage = group.score || 0;
              return (
                <div key={index} className={`presenter-card ${group.winner ? 'winner' : ''}`}>
                  <h3>{group.groupName}</h3>

                  <div className="progress-container">
                    <div className="progress-bar" style={{ width: `${scorePercentage}%` }}></div>
                  </div>
                  <p>{`${Math.round(scorePercentage)}%`}</p>

                  <p>
                    {group.totalCorrect} out of {group.totalSubmissions} submissions correct
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      );
    }

    // 1
    return (
      <div className="knowledge-container presenter">
        <div className="knowledge-header" style={{ position: 'absolute', top: '0' }}>
          {/* <img src={productImg} alt="Product Logo" className="knowledge-logo" /> */}
        </div>
        <div className="knowledge-content">
          <div className="knowledge-title-container">
            <div className="knowledge-title-wrapper">{renderInnerContent()}</div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="presenter-container-wrapper">
      {currentQuestionIndex !== sessionQuestions.length - 1 ? (
        <h2 style={{ position: 'absolute', top: '0', marginTop: 0 }}>
          Question: {currentQuestionIndex + 1} / {sessionQuestions.length - 1}
        </h2>
      ) : null}

      {renderBody()}
    </div>
  );
};

export default Presenter;
